import React from "react";

/**
 * AutoGridLayout - Automatically arranges form fields in a grid layout.
 */
const AutoGridLayout = ({ children, fields }) => {
  const columnCount = Math.min(fields.length, 6); // Max 6 columns

  return (
    <div
      className={`grid grid-cols-1 sm:grid-cols-${Math.min(columnCount, 2)}
                  md:grid-cols-${Math.min(columnCount, 4)}
                  lg:grid-cols-${columnCount} gap-4 w-full`}
    >
      {children}
    </div>
  );
};

export default AutoGridLayout;
